module.exports = __webpack_public_path__ + "static/media/ITC-TMI-2021-MarketAnalysisTools-PostCard-English.48e79122.pdf";